import React, {Fragment, useEffect, useRef, useState} from "react";
import {useDispatch} from "react-redux";

// controls
//helpers
import {
    formatDateFromFilter,
    formatDatetime,
    formatGeneralNumber,
    getGroupId,
    getEntityType,
    getMethodToFormatDuration,
    getNameUnitDriverForSubtables,
    getNameUnitDriverTag,
    isKPHAcronym,
    useHandleExportReport,
    convertUnitValue,
} from "Modules/reports/views/main/components/reportsTab/helper";

//hooks
import {useReportsSelector, useSidePanelMap} from "Core/hooks";
//actions
import {reportsMainGenerateReportUpdate,} from "Redux/actions";
import {Grid} from "@mui/material";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import InfiniteScrollTable from "Modules/reports/views/main/components/reportsTab/.components/infiniteScrollTable";
import {getAbbvTimezone} from "Components/uiControls/Timezone/tools";
import './tripReport.scss';
import AddressLandmark from "Modules/reports/views/main/components/reportsTab/.components/addressLandmark";

const ROW_PER_PAGE = 25;

const TripReport = (props) => {

    const {messages, report, user, copyReportToSetup, openReportSetup, scheduleReport, isActive} = props;
    const dispatch = useDispatch()
    const {durationFormat} = user;
    const {loading, asyncLoading, data, filters, timeZone} = report
    const {filterEntity, filterArray, filterType} = filters;
    const exportHandler = useHandleExportReport(report)
    const [SideMapComponent, onToggleSideMap] = useSidePanelMap();
    const [lastEntity, setLastEntity] = useState({});

    const startDayFilter = formatDateFromFilter(report.filters.startRange, timeZone)
    const endDayFilter = formatDateFromFilter(report.filters.endRange, timeZone)


    const reportRef = useRef();
    const entitiesArrayRef = useRef();
    const detailReportTableRef = useRef();
    const lastEntityRef = useRef({});
    const reportTableSelect = useReportsSelector(report, startDayFilter, endDayFilter, `MMMM DD, YYYY hh:mm A`, filterArray, filterType, timeZone)
    const unitDriverSelected = reportTableSelect.valueSelecteEntity?.length > 0 ? reportTableSelect.valueSelecteEntity : null;
    const dateSelected = reportTableSelect.dateSelected?.length > 0 ? reportTableSelect.dateSelected : null;
    useEffect(() => {
        if (report) {
            const newReport = JSON.parse(JSON.stringify(report));
            reportRef.current = newReport;
        }
    }, [JSON.stringify(report)]);

    useEffect(() => {
        if (isActive) {
            reportTableSelect.onChangeResetCache();
        }
    }, [isActive])


    const durationFormatTime = getMethodToFormatDuration(durationFormat);
    const buildTableHeader = () => {
        return (
            <Grid container item direction={"row"} className={"table-scroll-reports-title-details"}>
                <Grid item sm={2} className={'reports-cut-text'}>
                    {getNameUnitDriverForSubtables(filterEntity, messages)}
                </Grid>
                <Grid item sm={1} className={'reports-cut-text'}>
                    {messages['generatedReport_ignitionOn']}
                </Grid>
                <Grid item sm={2} className={'reports-cut-text'}>
                    {messages['generalReport_departure']}
                </Grid>
                <Grid item sm={1} className={'reports-cut-text'}>
                    {messages['generatedReport_ignitionOff']}
                </Grid>
                <Grid item sm={2} className={'reports-cut-text'}>
                    {messages['generalReport_arrive']}
                </Grid>
                <Grid item sm={1} className={'reports-cut-text'}>
                    {messages['generatedReport_driveTime']}
                </Grid>
                <Grid item sm={1} className={'reports-cut-text'}>
                    {messages['generatedReport_distance']}
                </Grid>
                <Grid item sm={1} className={'reports-cut-text'}>
                    {messages['generatedReport_stopTime']}
                </Grid>
                <Grid item sm={1} className={'reports-cut-text'}>
                    {messages['generatedReport_idleTime']}
                </Grid>
            </Grid>
        )
    }

    const TableViewGroup = ({index, style, content, id, previousItem}) => {
        const element = content?.recordInfo;
        const recordInfo = content?.recordInfo;

        return (
            <div
                className="listItem groupItem"
                id={id}
                key={id}
                style={style}
            >

                <Grid container direction={"column"} alignItems={"flex-start"} className='table-scroll-reports-group' style={{marginTop: "25px"}}>
                    <Grid container item className='table-scroll-reports-header'>
                        <Grid item sm={3}>

                            {
                                element?.tagId > 0 ?
                                    (<LocalOfferIcon
                                        style={{
                                            fontSize: "16.8px",
                                            color: `#${element.groupTagColor && element.groupTagColor != "ffffff" ? element.groupTagColor : "000"}`,
                                            position: 'absolute'
                                        }}/>)
                                    : ""
                            }
                            <span
                                className={`color-text-black ${element?.tagId > 0 ? 'report-home-header-padding' : ''}`}>{`${getNameUnitDriverTag(recordInfo?.groupLabel, messages)}`}</span>
                            {
                                report?.filters?.filterArray.length !== 1 && (<span
                                    className={'color-text-black report-home-header-padding-text'}>{` (${element?.tagId > 0 ? `${getNameUnitDriverTag(filterEntity, messages)} ` : ''}${recordInfo?.groupIndex} ${messages['OF']} ${recordInfo?.groupTotal})`}</span>)
                            }
                        </Grid>
                        <Grid item sm={9}>
<span
    className={'color-text-black'}>{formatDatetime(report.filters.startRange, "MMMM D, YYYY h:mm A", timeZone).toUpperCase()} - {formatDatetime(report.filters.endRange, "MMMM D, YYYY h:mm A", timeZone).toUpperCase()} ({getAbbvTimezone(timeZone)})</span>
                        </Grid>
                    </Grid>
                    <div className='table-scroll-reports-separator'></div>
                    <Grid item>
                        <p className='table-scroll-reports-label'>{element?.entityLabel}</p>
                    </Grid>
                </Grid>
                {buildTableHeader()}
            </div>
        )
    }

    const TableViewSummary = ({index, style, content, id, previousItem}) => {
        const item = content?.recordDetail;
        return (
            <div
                className="listItem groupItem"
                id={id}
                key={id}
                style={style}
            >
                <Grid container className='table-scroll-reports-group' style={{paddingTop: "1px", paddingBottom: "1px", backgroundColor: "#f5fafd", fontWeight: "bold"}}>
                    <div className='table-scroll-reports-separator'></div>
                    <Grid item sm={3} style={{marginTop: '10px', marginBottom: '10px'}}>
                        <strong>{
                            item.date &&
                            formatDatetime(
                                item.date,
                                `${"MMMM D, YYYY"}`
                            )
                        }</strong>
                    </Grid>
                    <Grid item sm={5} style={{marginTop: '10px', marginBottom: '10px'}}>
                        {messages['generalReport_overallTotal']}
                    </Grid>
                    <Grid item className={"report-ctn-text"} sm={1}>
                        {durationFormatTime(item.travelTime)}
                    </Grid>
                    <Grid item className={"report-ctn-text"} sm={1}>
                        {item.distance ? formatGeneralNumber(convertUnitValue(item.distance, item.isKPH, user.isKph)) : '0.00'} {messages[isKPHAcronym(user.isKph)]}
                    </Grid>
                    <Grid item className={"report-ctn-text"} sm={1}>
                        {durationFormatTime(item.stopTime)}
                    </Grid>
                    <Grid item className={"report-ctn-text"} sm={1}>
                        {durationFormatTime(item.idleTime)}
                    </Grid>
                </Grid>
            </div>
        )
    }

    const TableViewDetail = ({index, style, content, id, previousItem}) => {
        const element = content?.recordDetail;

        return (
            <div
                className="listItem detailItem"
                style={style}
                id={id}
                key={id}
            >
                <Grid container direction={"column"} style={{marginBottom: "10px", marginTop: "1px"}}>
                    <Grid container item direction={"row"} style={{paddingTop: "1px", paddingBottom: "1px"}}>
                        {
                            element.noData ?
                                <Grid item className={"report-ctn-text"} sm={12}>
                                    {messages["reportsMainRT_noDataEvent"]}
                                </Grid>
                                :
                                <>
                                    <Grid item className={"report-ctn-text"} sm={2}>
                                        {filterEntity === "Unit" ? (element?.driverName === 'Unassigned' ? messages['generatedReport_unassigned'] : element?.driverName) : element?.deviceLabel}
                                    </Grid>
                                    <Grid item className={"report-ctn-text"} sm={1}>
                                        {element.startTimeUTC && formatDatetime(element.startTimeUTC, `h:mm A`, timeZone)}
                                    </Grid>
                                    <Grid item className={"report-ctn-text"} sm={2}>
                                        <AddressLandmark onToggleSideMap={onToggleSideMap} messages={messages} element={{
                                            event: 'Ignition On',
                                            address: element?.departure,
                                            landmarkName: element?.startLandmarkName,
                                            landmarkId: element?.startLandmarkId,
                                        }} iconStyle={{fontSize: 18}} classNameButtonAddress={'report-address-button'}/>
                                    </Grid>
                                    <Grid item className={"report-ctn-text"} sm={1}>
                                        {element.endTimeUTC && formatDatetime(element.endTimeUTC, `h:mm A`, timeZone)}
                                    </Grid>
                                    <Grid item className={"report-ctn-text"} sm={2}>
                                        <AddressLandmark onToggleSideMap={onToggleSideMap} messages={messages} element={{
                                            event: 'Ignition Off',
                                            address: element?.arrive,
                                            landmarkName: element?.endLandmarkName,
                                            landmarkId: element?.endLandmarkId,
                                        }} iconStyle={{fontSize: 18}} classNameButtonAddress={'report-address-button'}/>
                                    </Grid>
                                    <Grid item className={"report-ctn-text"} sm={1}>
                                        {durationFormatTime(element.travelTime)}
                                    </Grid>
                                    <Grid item className={"report-ctn-text"} sm={1}>
                                        {element.distance ? formatGeneralNumber(convertUnitValue(element.distance, element.isKPH, user.isKph)) : '0.00'} {messages[isKPHAcronym(user.isKph)]}
                                    </Grid>
                                    <Grid item className={"report-ctn-text"} sm={1}>
                                        {element.isEndDataTime ? '' : durationFormatTime(element.stopTime)}
                                    </Grid>
                                    <Grid item className={"report-ctn-text"} sm={1}>
                                        {durationFormatTime(element.idleTime)}
                                    </Grid>
                                </>
                        }
                    </Grid>
                </Grid>
            </div>
        )
    }

    const renderItems = (parameters) => {
        const {content} = parameters;
        const type = content.recordInfo?.recordType;
        if (type === "GROUP") {
            const groupId = getGroupId(content)
            const entitiesArray = entitiesArrayRef.current || {};
            if (!entitiesArray[groupId]) {
                const newEntityArray = {...entitiesArray};
                newEntityArray[groupId] = content;
                entitiesArrayRef.current = newEntityArray
            }
            if (parameters.index === 0) {
                return;
            }

            return (
                <TableViewGroup {...parameters}></TableViewGroup>
            )
        } else if (type === "UNIT_SUMMARY") {
            return <TableViewSummary {...parameters}></TableViewSummary>;
        } else if (type === "DETAIL") {
            return <TableViewDetail {...parameters}></TableViewDetail>;
        }

        if (parameters.index === 0) {
            return;
        }

        return (
            <div>
                unknown type
            </div>
        )
    }

    const onStartIndex = (index) => {
        const item = data?.items[index];

        if (item) {
            if (item.recordInfo?.entityId !== lastEntityRef.current.recordInfo?.entityId) {
                setLastEntity(item)
            }
            lastEntityRef.current = item
        }
    }

    const renderHeader = () => {
        const groupId = getGroupId(lastEntity);
        const entitiesArray = entitiesArrayRef.current || {};
        const itemHeader = entitiesArray[groupId];

        if (itemHeader) {
            return (
                <TableViewGroup
                    style={{
                        backgroundColor: '#fff',
                        position: 'sticky',
                        top: 0,
                        zIndex: 2

                    }}
                    content={itemHeader}
                    id={itemHeader?.recordInfo?.entityId}
                ></TableViewGroup>
            );
        }
        return;

    };

    const type = getEntityType(report, messages);
    return (
        <>
            <InfiniteScrollTable
                refContainer={detailReportTableRef}
                renderItems={renderItems}
                loading={asyncLoading || loading}
                data={data.items || []}
                total={data.total}
                reportTitle={messages['reportsMainRT_tripReport']}
                editReport={() => {
                    copyReportToSetup({...report, data: []})
                }}
                onSchedule={() => {
                    scheduleReport(report)
                }}
                onCreate={openReportSetup}
                tableContainerClass={"detailed-report-reports-container"}
                type={type}
                runForType={report?.runForType}
                handleNewPageLoad={(page) => {
                    let currentReport = {...report};
                    currentReport.exportType = "json";
                    currentReport.filters = {
                        ...currentReport.filters,
                        unitsSelected: unitDriverSelected?.id != -99 ? unitDriverSelected : null,
                        accumulateData: true,
                        dateSelected: dateSelected?.id != -99 ? unitDriverSelected : null,
                    };
                    dispatch(reportsMainGenerateReportUpdate(currentReport, page, ROW_PER_PAGE))
                }}
                renderHeader={renderHeader}
                onStartIndex={onStartIndex}
                isActive={isActive}
                {...reportTableSelect}
                {...exportHandler}
            />
            <SideMapComponent hiddenButton hiddenSearchMap overlayClass={"overlay-class-reports"}/>
        </>
    );
};

export default TripReport;
